import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none" {...props}><circle cx="16" cy="16" r="14" strokeDasharray="90 90" stroke="currentColor" strokeWidth="4" /></svg>;